exports.components = {
  "component---src-pages-cookie-policy-index-js": () => import("./../../../src/pages/cookie-policy/index.js" /* webpackChunkName: "component---src-pages-cookie-policy-index-js" */)
}

